export default __webpack_public_path__ + "static/book3333-5013ee179b9e061516a34a239e6bd712.png";